export enum InvoiceSearchType {
	InvoiceSearch = 1,
	ProcessPaymentsSearch = 2,
}
